import type { StoreApi } from './types';

export const actions = {
	setSelectedProjectAris:
		(selectedProjectAris: string[]) =>
		({ setState }: StoreApi) => {
			setState({ selectedProjectAris });
		},
	hideSuggestionsReactionsButton:
		(taskId: string) =>
		({ getState, setState }: StoreApi) => {
			const { showReactionsButtonForSuggestions } = getState();
			const newState = {
				...showReactionsButtonForSuggestions,
				[taskId]: false,
			};
			setState({ showReactionsButtonForSuggestions: newState });
		},
};

export type Actions = typeof actions;
